const isBuffer = (obj: any) =>
  obj && obj.constructor && typeof obj.constructor.isBuffer === `function` && obj.constructor.isBuffer(obj);

const keyIdentity = (key: string) => key;

interface FlattenProps {
  target: Record<string, any>;
  opts?: {
    delimiter?: string;
    maxDepth?: number;
    transformKey?: (key: string) => string;
    safe?: boolean;
  };
}

const defaultOpts = {
  delimiter: `.`,
  maxDepth: undefined,
  transformKey: keyIdentity,
  safe: false,
};

const flatten = ({ target, opts }: FlattenProps) => {
  const delimiter = opts?.delimiter ?? defaultOpts.delimiter;
  const maxDepth = opts?.maxDepth ?? defaultOpts.maxDepth;
  const transformKey = opts?.transformKey ?? defaultOpts.transformKey;

  const output: Record<string, any> = {};

  const step = (object: any, prev?: any, currentDepth?: any) => {
    // eslint-disable-next-line no-param-reassign
    currentDepth = currentDepth || 1;

    // eslint-disable-next-line consistent-return
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const isarray = opts?.safe && Array.isArray(value);
      const type = Object.prototype.toString.call(value);

      const isbuffer = isBuffer(value);
      const isobject = type === `[object Object]` || type === `[object Array]`;

      const newKey = prev ? `${prev}${delimiter}${transformKey(key)}` : transformKey(key);

      if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1);
      }

      output[newKey] = value;
    });
  };

  step(target);

  return output;
};

export default flatten;
